import { render, staticRenderFns } from "./SettingsShippingAttributeConfig.vue?vue&type=template&id=636fd96c&scoped=true&"
import script from "./SettingsShippingAttributeConfig.vue?vue&type=script&lang=js&"
export * from "./SettingsShippingAttributeConfig.vue?vue&type=script&lang=js&"
import style0 from "./SettingsShippingAttributeConfig.vue?vue&type=style&index=0&id=636fd96c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636fd96c",
  null
  
)

export default component.exports